module.exports = __webpack_public_path__ + "img/Open-ended_Feedback_24@2x.787dd11d.png";